const defaultObj = {
    it: '-',
    en: '-'
}

/**
 * Object representing an ANM22 Table Class
 * @class
 */
export class TableClass {

    /**
     * @param {Array} objs The array of objects of the Table Class
     */
    constructor(objs) {
        this.objs = objs;
    }

    /**
     * Returns all objects of the Table Class
     */
    getAll() {
        return this.objs;
    }

    /**
     * @param {String} id Id of the element
     * @returns {Object} Selected element of the table class or default if missing
     */
    getById(id) {
        if(this.objs[id]) {
            return this.objs[id];
        } else {
            return defaultObj;
        }
    }

    /**
     * Returns an element of the table class based on its description in a certain language
     * @param {String} desc The string representing the description of the object in a language
     * @param {String} lang Language of the description
     */
    getByDescOfLang(desc, lang) {
        this.objs.forEach(obj => {
            if(obj[lang] === desc) {
                return obj;
            }
        });
        return defaultObj;
    }
}